module.exports = __webpack_public_path__ + "static/img/logo.69cdf832.png";